import { render } from "./Products.vue?vue&type=template&id=9e27076c"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
script.render = render

export default script